import { Link } from 'react-router-dom';
import styled from 'styled-components';
const utilities = require("./utilities");

const TokenLink = styled(Link)`
display:block;
margin-bottom :10px;
&:focus, &:hover, &:visited, &:link, &:active {
    color:#fff;
}
&:hover{
    color:#00ff00;
}
`;


const CollectionTokenCard = ({tokens}) => (
        <div className='tokenBox'>
            <div className='MytokenCard'><iframe id={tokens.tokenId} sandbox="allow-scripts allow-same-origin" frameBorder="0" srcDoc={tokens.animationURL}></iframe></div>
            <div className='MainTokenInfo'>
                <TokenLink to={`/cypherdude/${tokens.tokenId}`} className='TokenName'>{tokens.name}</TokenLink>
            </div>
        </div>
    )
export default CollectionTokenCard;
